import React from 'react';
import styled from 'styled-components';
import SeatMapSelector from '@src/components/SeatMap/SeatMapSelector';
import ProductAdderOngoingCartResume from './ProductAdderSummary';
import { SimpleDivisor } from '@src/components/reusable';
import ProductAdderFooterButtons from './ProductAdderFooterButtons';
import { useProductSeatmapSelection } from '@src/domains/products/hooks/useProductSeatmapSelection';

const ProductAdderSeatMap = ({ isMultiProductFlow = false }: { isMultiProductFlow?: boolean }) => {
  const { selectedHour, selectedTariffs, scheduling, selectSeatFromMap } = useProductSeatmapSelection();

  return (
    <ProductAdderSeatMapStyles>
      <ProductAdderOngoingCartResume hideResources={true} />
      <SimpleDivisor margin={20} />
      <SeatMapContainer>
        <SeatMap>
          <SeatMapSelector
            scheduling={scheduling!}
            timeMinutes={selectedHour}
            selectedTariffs={selectedTariffs}
            onSelectionChange={selectSeatFromMap}
          />
        </SeatMap>
      </SeatMapContainer>
      <ProductAdderFooterButtons isMultiProductFlow={isMultiProductFlow} />
    </ProductAdderSeatMapStyles>
  );
};

export default ProductAdderSeatMap;

const SeatMap = styled.div`
  width: 100%;
`;

const SeatMapContainer = styled.div`
  display: flex;
  margin-bottom: 1.5vh;
`;
const ProductAdderSeatMapStyles = styled.div``;
